import { stdObject } from "../../../../data/types/stdObject";

export const updateItemCommissions = (
  data: stdObject,
  { windowValues2, setWindowValues2 }: stdObject,
) => {
  console.log("data", data);
  const { status, index, value, item, GRUCOZ, AGECOZ, PORCOZ } = data;

  let tempValues = windowValues2;
  switch (status) {
    case "add":
      tempValues.commissions.push(
        item
          ? {
              GRUCOZ,
              AGECOZ,
              PORCOZ,
            }
          : {},
      );
      break;
    case "update":
      tempValues.commissions[index].PORCOZ = value;
      break;
    case "delete":
      tempValues.commissions.splice(index, 1);
      break;
    default:
      break;
  }
  setWindowValues2({ ...tempValues });
};
